/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_Recovery_Code_Redemption_FailedInputs */

const nl_auth_password_errors_recovery_code_redemption_failed = /** @type {(inputs: Auth_Password_Errors_Recovery_Code_Redemption_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herstelcode is ongeldig of al gebruikt`)
};

/**

* @param {Auth_Password_Errors_Recovery_Code_Redemption_FailedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_recovery_code_redemption_failed = /** @type {((inputs?: Auth_Password_Errors_Recovery_Code_Redemption_FailedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_Recovery_Code_Redemption_FailedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_recovery_code_redemption_failed(inputs)
});
export { auth_password_errors_recovery_code_redemption_failed as "auth.password_errors.recovery_code_redemption_failed" }